import PipModelAdapter from './pip-model-adapter';

const buyboxQuantityErrorClass = 'buybox__quantity--error';
const quantityBoxSelectorInput = '#buybox__quantity__input';
class QuantityInput {
	static updateQuantityError(ffm, fulfillmentDetails, pickupDetails) {
		try {
			if (this.exceedsAvailableQuantity(ffm, fulfillmentDetails, pickupDetails)) {
				showWarning();
			} else {
				hideWarning();
			}
		} catch (e) {
			console.error(e);
		}
	}

	static exceedsAvailableQuantity(ffm, fulfillmentDetails, pickupDetails) {
		let exceeds = false;
		try {
			if (window && window.$) {
				const currentQuantity = window.$(quantityBoxSelectorInput).val();
				// console.log("updateQuantityError()", currentQuantity, ffm, storeQuantity, onlineQuantity);
				if (ffm === 'PICKUP' && pickupDetails.type === 'BOPIS') {
					exceeds = currentQuantity > fulfillmentDetails.storeQuantity;
					if (exceeds && pickupDetails && pickupDetails.nearbyStore && pickupDetails.nearbyStore.quantity) {
						exceeds = currentQuantity > pickupDetails.nearbyStore.quantity;
					}
				} else if (
					ffm === 'STH' ||
					(ffm === 'PICKUP' && pickupDetails.type === 'BOSS') /* || BOSS */
				) {
					exceeds = currentQuantity > fulfillmentDetails.onlineQuantity;
				}
			}
		} catch (e) {
			console.error(e);
		}
		return exceeds;
	}

	

	static updateTileForBossBopisSharedSku(ffm, model, setDetails) {
		if (model.fulfillmentDetails.quantityError) {
			if (ffm === 'PICKUP' && model.fulfillmentDetails.isBossBopisSharedTile) {
                model.fulfillmentDetails.pickupType = 'BOSS';
				model.pickupDetails = PipModelAdapter.getPickupDetailsForBossShared(model, true);
			}
		} else {
			if (ffm === 'PICKUP' && model.fulfillmentDetails.isBossBopisSharedTile) {
				model.fulfillmentDetails.pickupType = 'BOPIS';
				model.pickupDetails = PipModelAdapter.getPickupDetailsForBossShared(model, false);
			}
		}
		setDetails({ ...model });
	}
}

function showWarning() {
	if (window && window.$) {
		window.$(quantityBoxSelectorInput).addClass(buyboxQuantityErrorClass);
	}
}

function hideWarning() {
	if (window && window.$) {
		window.$(quantityBoxSelectorInput).removeClass(buyboxQuantityErrorClass);
	}
}



export default QuantityInput;
